var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[(_vm.isUserLoggedIn)?_c('v-flex',{attrs:{"xs6":""}},[_c('songs-bookmarks'),_vm._v(" "),_c('recently-viewed-songs',{staticClass:"mt-2"})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"ml-2",class:{
      xs12: !_vm.isUserLoggedIn,
      xs6: _vm.isUserLoggedIn
    }},[_c('songs-search-panel'),_vm._v(" "),_c('songs-panel',{staticClass:"mt-2"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21b0860d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Songs/Index.vue
// module id = null
// module chunks = 